<template>
  <div>
    <el-alert
      title="草稿确认后，未下推的明细可以生成主订单。全部下推后计划关闭。若这份草稿主订单被删除，计划会退回已确认，可以再次生成。生成时按销售价目取生效单价和币种；没有价目则单价为 0、币种为人民币。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.salesPlanCode" clearable placeholder="计划号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.customerName" clearable placeholder="客户" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.planState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已确认" value="01" />
        <el-option label="已关闭" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="salesPlanCode" label="计划号" width="190" />
      <el-table-column prop="salesPlanName" label="名称" min-width="140" show-overflow-tooltip />
      <el-table-column prop="customerName" label="客户" min-width="140" show-overflow-tooltip />
      <el-table-column prop="dateFrom" label="计划起" width="120" />
      <el-table-column prop="dateTo" label="计划止" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="stateType(row.planState)">{{ stateLabel(row.planState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="310" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openView(row.salesPlanId)">查看</el-button>
          <el-button type="text" :disabled="row.planState !== '00'" @click="openEdit(row.salesPlanId)">修改</el-button>
          <el-button type="text" :disabled="row.planState !== '00'" @click="confirmRow(row.salesPlanId)">确认</el-button>
          <el-button type="text" :disabled="row.planState !== '01'" @click="unconfirmRow(row.salesPlanId)">反确认</el-button>
          <el-button type="text" :disabled="row.planState !== '01'" @click="genRow(row.salesPlanId)">生成主订单</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.planState !== '00'" @click="onDelete(row.salesPlanId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.salesPlanId ? '修改销售计划' : '新增销售计划'" :visible.sync="visible" width="980px" :close-on-click-modal="false">
      <el-form :model="form" label-width="90px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="计划号"><el-input v-model="form.salesPlanCode" placeholder="留空自动生成" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称"><el-input v-model="form.salesPlanName" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户" required>
              <el-select v-model="form.customerId" filterable clearable placeholder="请选择客户" style="width:100%">
                <el-option v-for="c in companies" :key="c.companyId" :label="(c.companyNumber ? c.companyNumber + ' / ' : '') + c.companyName" :value="c.companyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划起">
              <el-date-picker v-model="form.dateFrom" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划止">
              <el-date-picker v-model="form.dateTo" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
          </el-col>
        </el-row>
        <el-button v-if="isDraft" type="primary" size="mini" style="margin-bottom:8px" @click="openProductPicker">从产品库添加</el-button>
        <el-table :data="form.lineList" border size="small">
          <el-table-column prop="productNumber" label="产品编码" width="140" show-overflow-tooltip />
          <el-table-column prop="productName" label="产品名称" min-width="160" show-overflow-tooltip />
          <el-table-column label="计划数量" width="150">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.plannedQty" :min="0.0001" :precision="4" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="交期" width="160">
            <template slot-scope="{ row }">
              <el-date-picker v-model="row.deadline" type="date" value-format="yyyy-MM-dd" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column v-if="isDraft" label="操作" width="70" align="center">
            <template slot-scope="{ $index }"><el-button type="text" @click="form.lineList.splice($index, 1)">删除</el-button></template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="'销售计划 ' + (detail.salesPlanCode || '')" :visible.sync="detailVisible" width="900px">
      <p>
        <b>客户：</b>{{ detail.customerName || '-' }}
        <b style="margin-left:16px">期间：</b>{{ detail.dateFrom || '-' }} ~ {{ detail.dateTo || '-' }}
        <b style="margin-left:16px">状态：</b>{{ stateLabel(detail.planState) }}
      </p>
      <el-table :data="detail.lineList || []" border size="small">
        <el-table-column type="index" width="50" />
        <el-table-column prop="productNumber" label="产品编码" width="140" />
        <el-table-column prop="productName" label="产品名称" min-width="140" />
        <el-table-column prop="plannedQty" label="计划量" width="100" align="right" />
        <el-table-column prop="orderedQty" label="已下推" width="100" align="right" />
        <el-table-column prop="deadline" label="交期" width="110" />
        <el-table-column prop="masterOrderCode" label="主订单" width="180" />
      </el-table>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>

    <el-dialog title="选择产品" :visible.sync="productPickerVisible" width="860px" append-to-body :close-on-click-modal="false">
      <div class="toolbar" style="margin-bottom:12px">
        <el-input v-model="picker.productNumber" clearable placeholder="产品编码" style="width:180px" @keyup.enter.native="searchProductPicker" />
        <el-input v-model="picker.productName" clearable placeholder="产品名称" style="width:180px" @keyup.enter.native="searchProductPicker" />
        <el-button type="primary" icon="el-icon-search" @click="searchProductPicker">查询</el-button>
      </div>
      <el-table
        ref="productTable"
        :data="productPickerList"
        border
        row-key="productId"
        v-loading="productPickerLoading"
        height="360"
        @selection-change="productPickerSelection = $event"
      >
        <el-table-column type="selection" width="48" align="center" :reserve-selection="true" />
        <el-table-column prop="productNumber" label="产品编码" width="160" />
        <el-table-column prop="productName" label="产品名称" min-width="180" show-overflow-tooltip />
      </el-table>
      <list-pagination
        :total="pickerTotal"
        :page="pickerPage"
        :page-size="pickerPageSize"
        :page-sizes="[10, 20, 50]"
        @current-change="onPickerPage"
        @size-change="onPickerSize"
      />
      <div slot="footer">
        <el-button @click="productPickerVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmProducts">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listSalesPlan, getSalesPlan, saveSalesPlan, updateSalesPlan, deleteSalesPlan,
  confirmSalesPlan, unconfirmSalesPlan, generateMasterOrderFromPlan
} from '../../api/salesPlan'
import { listProduct } from '../../api/product'
import { selectCompany } from '../../api/staff'

function emptyForm() {
  return {
    salesPlanId: '', salesPlanCode: '', salesPlanName: '', customerId: '',
    dateFrom: null, dateTo: null, remark: '', planState: '', lineList: []
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { salesPlanCode: '', customerName: '', planState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, detailVisible: false, detail: {},
      form: emptyForm(),
      companies: [],
      productPickerVisible: false,
      productPickerLoading: false,
      productPickerList: [],
      productPickerSelection: [],
      picker: { productNumber: '', productName: '' },
      pickerPage: 1,
      pickerPageSize: 10,
      pickerTotal: 0
    }
  },
  computed: {
    isDraft() {
      return !this.form.planState || this.form.planState === '00'
    }
  },
  created() {
    this.load()
    selectCompany().then(res => { this.companies = res.data || [] }).catch(() => {})
  },
  methods: {
    stateLabel(s) { return s === '01' ? '已确认' : s === '02' ? '已关闭' : '草稿' },
    stateType(s) { return s === '01' ? 'success' : s === '02' ? 'info' : '' },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listSalesPlan({
        currentPage: this.page, pageSize: this.pageSize,
        salesPlanCode: this.query.salesPlanCode,
        customerName: this.query.customerName,
        planState: this.query.planState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openProductPicker() {
      this.picker = { productNumber: '', productName: '' }
      this.pickerPage = 1
      this.productPickerSelection = []
      this.productPickerVisible = true
      this.$nextTick(() => {
        if (this.$refs.productTable) this.$refs.productTable.clearSelection()
      })
      this.loadProductPicker()
    },
    searchProductPicker() {
      this.pickerPage = 1
      this.loadProductPicker()
    },
    onPickerPage(p) {
      this.pickerPage = p
      this.loadProductPicker()
    },
    onPickerSize(s) {
      this.pickerPageSize = s
      this.pickerPage = 1
      this.loadProductPicker()
    },
    loadProductPicker() {
      this.productPickerLoading = true
      listProduct({
        currentPage: this.pickerPage,
        pageSize: this.pickerPageSize,
        productNumber: this.picker.productNumber,
        productName: this.picker.productName,
        active: '1'
      }).then(res => {
        const body = res.data || {}
        this.productPickerList = body.list || []
        this.pickerTotal = body.totalCount || 0
      }).finally(() => { this.productPickerLoading = false })
    },
    confirmProducts() {
      const rows = this.productPickerSelection || []
      if (!rows.length) {
        this.$message.warning('请选择产品')
        return
      }
      if (!this.form.lineList) this.form.lineList = []
      rows.forEach(p => {
        if (!p || !p.productId) return
        this.form.lineList.push({
          productId: p.productId,
          productNumber: p.productNumber,
          productName: p.productName,
          plannedQty: 1,
          deadline: this.form.dateTo || null
        })
      })
      this.productPickerVisible = false
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getSalesPlan(id).then(res => {
        const d = res.data || {}
        this.form = {
          salesPlanId: d.salesPlanId,
          salesPlanCode: d.salesPlanCode,
          salesPlanName: d.salesPlanName,
          customerId: d.customerId || '',
          dateFrom: d.dateFrom || null,
          dateTo: d.dateTo || null,
          remark: d.remark,
          planState: d.planState,
          lineList: (d.lineList || []).map(l => ({
            productId: l.productId,
            productNumber: l.productNumber,
            productName: l.productName,
            plannedQty: l.plannedQty == null ? undefined : Number(l.plannedQty),
            deadline: l.deadline || null
          }))
        }
        this.visible = true
      })
    },
    openView(id) {
      getSalesPlan(id).then(res => {
        this.detail = res.data || {}
        this.detailVisible = true
      })
    },
    submit() {
      if (!this.form.customerId) {
        this.$message.warning('请选择客户')
        return
      }
      const lineList = (this.form.lineList || []).filter(l => l.productId && Number(l.plannedQty) > 0)
      if (!lineList.length) {
        this.$message.warning('请添加明细')
        return
      }
      this.saving = true
      const payload = {
        salesPlanId: this.form.salesPlanId || undefined,
        salesPlanCode: this.form.salesPlanCode || undefined,
        salesPlanName: this.form.salesPlanName || undefined,
        customerId: this.form.customerId,
        dateFrom: this.form.dateFrom || null,
        dateTo: this.form.dateTo || null,
        remark: this.form.remark,
        lineList: lineList.map(l => ({
          productId: l.productId,
          plannedQty: l.plannedQty,
          deadline: l.deadline || null
        }))
      }
      const req = this.form.salesPlanId ? updateSalesPlan(payload) : saveSalesPlan(payload)
      req.then(() => {
        this.$message.success('已保存')
        this.visible = false
        this.load()
      }).finally(() => { this.saving = false })
    },
    confirmRow(id) {
      this.$confirm('确认销售计划？确认后可生成主订单', '提示', { type: 'warning' }).then(() => {
        confirmSalesPlan(id).then(() => { this.$message.success('已确认'); this.load() })
      }).catch(() => {})
    },
    unconfirmRow(id) {
      this.$confirm('反确认后将退回草稿，可修改或删除；已生成主订单的计划不能反确认。', '提示', { type: 'warning' }).then(() => {
        unconfirmSalesPlan(id).then(() => { this.$message.success('已反确认'); this.load() })
      }).catch(() => {})
    },
    genRow(id) {
      this.$confirm('将未下推明细生成一张主订单？', '生成主订单', {
        distinguishCancelAndClose: true,
        confirmButtonText: '生成并确认主订单',
        cancelButtonText: '仅生成草稿',
        type: 'warning'
      }).then(() => this.generate(id, true)).catch(action => {
        if (action === 'cancel') this.generate(id, false)
      })
    },
    generate(id, autoConfirm) {
      generateMasterOrderFromPlan({ salesPlanId: id, autoConfirm }).then(res => {
        const code = (res.data && res.data.masterOrderCode) || ''
        this.$message.success((autoConfirm ? '已生成并确认主订单 ' : '已生成主订单草稿 ') + code)
        this.load()
      })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteSalesPlan([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
